<template>
  <section>
    <p class="title is-1">Reporte de apartados</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Apartados</b-breadcrumb-item>
    </b-breadcrumb>

    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <div class="field mt-4">
      <div class="field has-addons">
        <div class="control is-expanded">
          <busqueda-cliente @seleccionado="onSeleccionado" @deseleccionado="onDeseleccionado" />
        </div>
      </div>
    </div>
    <b-modal v-model="abrirModalLocal" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
      aria-label="Modal Seleccionar Local" close-button-aria-label="Close" aria-modal>
      <div class="modal-card" style="width: 320px">
        <section class="modal-card-body">
          <b-field class="mt-3" label="Local emisor">
            <b-select class="wide" placeholder="Seleccionar..." v-model="local" required>
              <option value="jiro">Jirosushi Prime</option>
              <option value="ccs">Oferta Caracas</option>
              <option value="prime">Food Prime</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button label="Continuar" type="is-primary" @click="confirmarLocal" :disabled="!local" />
        </footer>
      </div>
    </b-modal>
    <mensaje-inicial class="mt-2" :titulo="'No se han encontrado apartados :('"
      :subtitulo="'Aquí aparecerán los apartados registrados'" v-if="apartados.length < 1" />
    <div class="mt-2" v-if="apartados.length > 0">
      <cartas-totales-filtradas :registros="totalesGenerales" />
      <cartas-totales-filtradas :registros="apartadosFiltrados" />
      <tabla-cuentas-apartados :datos="apartados" @imprimir="onGenerarComprobante" :printHref="printHref"
        @actualizar-cuentas="obtenerApartados" @cargarRegistrosFiltrados="guardarCuentasApartadosFiltrados"
        :filtros="filtrosCompletos" :tasa="tasa" :currentPage="currentPage" :perPage="perPage" :total="total"
        @page-change="onPageChange" @per-page-change="onPerPageChange" />
    </div>
    <comprobante-compra :venta="this.apartadoSeleccionado" :tipo="'apartado'" @impreso="onImpreso"
      v-if="mostrarComprobante" :porPagar="porPagar" :tamaño="tamaño" :local="local" :enviarCliente="enviarCliente"
      :tasa="tasa" />
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha'
import MensajeInicial from '../Extras/MensajeInicial'
import CartasTotalesFiltradas from '../Extras/CartasTotalesFiltradas'
import TablaCuentasApartados from './TablaCuentasApartados'
import ComprobanteCompra from './ComprobanteCompra'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: "ReporteApartados",
  components: { BusquedaEnFecha, TablaCuentasApartados, MensajeInicial, CartasTotalesFiltradas, ComprobanteCompra, BusquedaCliente },

  data: () => ({
    tasa: null,
    filtros: {
      fechaInicio: "",
      fechaFin: ""
    },
    tamaño: 'tiquera',
    porPagar: 0,
    cargando: false,
    apartados: [],
    currentPage: 1,
    perPage: 5,
    total: 0,
    totalesGenerales: [],
    apartadoSeleccionado: null,
    mostrarComprobante: false,
    enviarCliente: false,
    clienteId: null,
    apartadosFiltrados: [],
    local: null,
    abrirModalLocal: false,
  }),

  mounted ()
  {
    this.obtenerApartados()
  },

  computed: {
    printHref ()
    {
      let href = '#/pdf/apartados'

      const entries = Object.entries(this.filtros)
        .filter(entry => Boolean(entry[1]))

      if (this.clienteId) {
        entries.push(['clienteId', this.clienteId])
      }

      if (entries.length === 0) return href

      const filtros = Object.fromEntries(entries)
      const params = new URLSearchParams(filtros).toString()
      return `${href}?${params}`
    },

    filtrosCompletos ()
    {
      return {
        ...this.filtros,
        clienteId: this.clienteId || null,
        tipo: 'apartado',
      }
    },
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    onImpreso (resultado)
    {
      this.mostrarComprobante = resultado
    },

    confirmarLocal ()
    {
      this.abrirModalLocal = false;
      this.confirmarEnvioCliente();
    },

    confirmarEnvioCliente ()
    {
      this.$buefy.dialog.confirm({
        message: '¿Enviar al cliente mediante WhatsApp?',
        cancelText: 'No',
        confirmText: 'Sí',
        trapFocus: true,
        onConfirm: () =>
        {
          this.enviarCliente = true
          this.mostrarComprobante = true
        },
        onCancel: () =>
        {
          this.enviarCliente = false
          this.mostrarComprobante = true
        },
      })
    },

    async onGenerarComprobante (apartado)
    {
      this.cargando = true

      try {
        const detalle = await HttpService.obtenerConConsultas('ventas.php', {
          accion: 'obtener_cuenta_apartado',
          id: apartado.id,
          tipo: 'apartado',
        })

        if (!detalle || !Array.isArray(detalle.productos) || detalle.productos.length < 1) {
          this.$buefy.toast.open({
            message: 'No se pudieron cargar los productos de este apartado',
            type: 'is-danger'
          })
          return
        }

        this.apartadoSeleccionado = detalle
        this.porPagar = Number(detalle.total || 0) - Number(detalle.pagado || 0)
        if (detalle.idNegocio) {
          const mapa = { 1: 'jiro', 2: 'ccs', 3: 'prime' }
          this.local = mapa[detalle.idNegocio] || null
        } else {
          this.local = null
        }

        this.$buefy.dialog.confirm({
          message: 'Selecciona el tamaño a imprimir',
          cancelText: 'Carta',
          confirmText: 'Tiquera',
          trapFocus: true,
          onConfirm: () =>
          {
            this.tamaño = 'tiquera'
            if (this.local) {
              this.confirmarEnvioCliente()
            } else {
              this.abrirModalLocal = true
            }
          },
          onCancel: () =>
          {
            this.tamaño = 'carta'
            if (this.local) {
              this.confirmarEnvioCliente()
            } else {
              this.abrirModalLocal = true
            }
          },
        })
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Ocurrió un error al cargar el comprobante del apartado',
          type: 'is-danger'
        })
      } finally {
        this.cargando = false
      }
    },

    onBusquedaEnFecha (fechas)
    {
      this.currentPage = 1
      this.filtros.fechaInicio = fechas && fechas[0] ? fechas[0].toISOString().split('T')[0] : ''
      this.filtros.fechaFin = fechas && fechas[1] ? fechas[1].toISOString().split('T')[0] : ''
      this.obtenerApartados()
    },

    onPageChange (page)
    {
      this.currentPage = page
      this.obtenerApartados()
    },

    onPerPageChange (perPage)
    {
      // Convert null (Buefy "Todos") to 0 for backend
      this.perPage = perPage === null ? 0 : perPage
      this.currentPage = 1
      this.obtenerApartados()
    },

    async obtenerApartados ()
    {
      this.cargando = true
      let payload = {
        filtros: {
          ...this.filtros,
          clienteId: this.clienteId || null,
          pagina: this.perPage === null ? null : this.currentPage,
          limite: this.perPage,
        },
        accion: 'obtener_apartados'
      }
      HttpService.obtenerConConsultas('ventas.php', payload)
        .then(resultado =>
        {
          this.apartados = resultado.apartados
          this.total = resultado.total
          this.tasa = resultado.tasa.valor ?? 0;
          this.apartadosFiltrados = resultado.apartadosFiltrados.map(apartado =>
          {
            return {
              nombre: apartado.metodo_pago,
              total: `${this.formatoMonto(apartado.total)}`,
              totalBs: `${this.formatoMonto(apartado.totalBs)}`,
              icono: 'credit-card-outline',
              clase: 'has-text-info',
              cantidad: apartado.cuentas_apartados_totales,
            }
          })

          this.guardarCuentasApartadosFiltrados()

          this.totalesGenerales = [
            { nombre: "# Apartados", total: this.total, icono: "wallet-travel", clase: "has-text-primary" },
            { nombre: "Total ", total: '$' + this.formatoMonto(resultado.totalApartados), icono: "cash-fast", clase: "has-text-success" },
            { nombre: "Por pagar Dólares", total: '$' + this.formatoMonto(resultado.totalPorPagar), icono: "alert", clase: "has-text-danger" },
            { nombre: "Por pagar Bolívares", total: 'Bs. ' + this.formatoMonto(resultado.totalPorPagar * this.tasa), icono: "alert", clase: "has-text-danger" },
            { nombre: "Pagos", total: '$' + this.formatoMonto(resultado.totalPagos), icono: "account-cash", clase: "has-text-grey-light" },
            { nombre: "# Productos", total: resultado.totalProductosVendidos, icono: "package-variant", clase: "has-text-warning" },
            { nombre: "Ganancia", total: '$' + this.formatoMonto(resultado.totalGanancia), icono: "currency-usd", clase: "has-text-info" }
          ]
          this.cargando = false
        })
    },

    guardarCuentasApartadosFiltrados ()
    {
      const apartadosFiltrados = this.apartadosFiltrados.map(apartado =>
      {
        return {
          nombre: apartado.nombre,
          total: apartado.total,
          totalBs: apartado.totalBs,
          cantidad: apartado.cantidad,
        }
      })
      localStorage.setItem('metodos_pago', JSON.stringify(apartadosFiltrados));
    },


    onDeseleccionado ()
    {
      this.clienteId = null
      this.currentPage = 1
      this.obtenerApartados()
    },

    onSeleccionado (cliente)
    {
      this.clienteId = cliente.id
      this.currentPage = 1

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() =>
      {
        this.obtenerApartados();
      }, 500);
    },
  }
}
</script>
